// Copyright (c) 2026, IPivot. All rights reserved.
'use strict';

import { PendingChange } from '../data';
import { DiffContent } from './MergeDiffDialog';

function DiffHoverPanel({ change }: { change: PendingChange | null }) {
    if (!change) return null;
    const detail = change.detail || {};
    const isCat = Boolean(detail.categoryKey || (detail.category && !detail.pvkey));
    const key = isCat
        ? (detail.categoryKey || detail.after?.key || detail.before?.key || '')
        : (detail.pvkey || detail.after?.pvkey || detail.before?.pvkey || '');
    const op = change.proposal_type;

    return (
        <div
            style={{
                position: 'fixed',
                top: '10vh',
                right: 0,
                width: 480,
                maxHeight: '80vh',
                overflowY: 'auto',
                background: '#0d1117',
                color: '#e6edf3',
                borderLeft: '1px solid #30363d',
                borderTop: '1px solid #30363d',
                borderBottom: '1px solid #30363d',
                borderRadius: '6px 0 0 6px',
                boxShadow: '-4px 0 24px rgba(0,0,0,0.5)',
                zIndex: 1040,
                pointerEvents: 'none',
            }}
        >
            <div style={{ background: '#161b22', borderBottom: '1px solid #30363d', padding: '8px 14px' }}>
                <span style={{ fontFamily: 'monospace', fontSize: '0.85rem', color: '#e6edf3' }}>{key}</span>
                <span className="ms-2 text-muted" style={{ fontSize: '0.75rem' }}>{isCat ? 'category' : 'fingerprint'} · {op}</span>
            </div>
            <div style={{ padding: '12px 14px' }}>
                <DiffContent change={change} />
            </div>
        </div>
    );
}

export default DiffHoverPanel;